import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { ScheduledRoundsAvailabilityStore } from 'src/app/core/stores/scheduled-rounds-availability.store';

@Injectable({
  providedIn: 'root',
})
export class ScheduledRoundsAvailabilityGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly scheduledRoundsAvailabilityStore = inject(ScheduledRoundsAvailabilityStore);

  canActivate(): Observable<boolean | UrlTree> | boolean | UrlTree {
    return this.scheduledRoundsAvailabilityStore.resolveAvailability().pipe(
      map(isEnabled => (isEnabled ? true : this.router.parseUrl('/homepage')))
    );
  }
}
